import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {usePresentationParams} from '../../hooks/usePresentationParams';
import {useCaptureRedirectUri} from '../../hooks/useCaptureRedirectUri';
import PresLoaderWrapper from './PresLoaderWrapper';

function PresWrapper(): JSX.Element {
    const {presentationId} = usePresentationParams();
    useCaptureRedirectUri();

    if (!presentationId) {
        return <Navigate replace to="/" />;
    }

    return (
        <PresLoaderWrapper>
            <Outlet />
        </PresLoaderWrapper>
    );
}

export default PresWrapper;
